import React from 'react'
import CountUp from 'react-countup'

const SummaryCards = ({ reportData }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      <div className="bg-white p-4 rounded-lg shadow-sm border">
        <p className="text-xs font-medium text-gray-500 mb-1">
          Total Units
        </p>
        <p className="text-xl font-semibold text-gray-900">
          <CountUp end={reportData.totals?.count || 0} />
        </p>
      </div>

      <div className="bg-white p-4 rounded-lg shadow-sm border">
        <p className="text-xs font-medium text-gray-500 mb-1">
          Sold Units
        </p>
        <p className="text-xl font-semibold text-gray-900">
          <CountUp end={reportData.byStatus?.['sold-out']?.count || 0} />
        </p>
      </div>

      <div className="bg-white p-4 rounded-lg shadow-sm border">
        <p className="text-xs font-medium text-gray-500 mb-1">
          Available Units
        </p>
        <p className="text-xl font-semibold text-gray-900">
          <CountUp end={reportData.byStatus?.available?.count || 0} />
        </p>
      </div>

      <div className="bg-white p-4 rounded-lg shadow-sm border">
        <p className="text-xs font-medium text-gray-500 mb-1">
          Booked Units
        </p>
        <p className="text-xl font-semibold text-gray-900">
          <CountUp end={reportData.byStatus?.booked?.count || 0} />
        </p>
      </div>
    </div>
  )
}

export default SummaryCards


